/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationPrivacyUpdate } from '../../axios/organisationPrivacyUpdate'
import type {
	OrganisationPrivacyUpdateError,
	OrganisationPrivacyUpdatePathParams,
	OrganisationPrivacyUpdateRequest,
	OrganisationPrivacyUpdateResponse,
} from '../../types/OrganisationPrivacyUpdate'

export const organisationPrivacyUpdateMutationKey = () => [{ url: '/organisations/:organisation/privacy' }] as const

export type OrganisationPrivacyUpdateMutationKey = ReturnType<typeof organisationPrivacyUpdateMutationKey>

export type OrganisationPrivacyUpdateVariables = {
	organisation: OrganisationPrivacyUpdatePathParams['organisation']
	data: OrganisationPrivacyUpdateRequest
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationPrivacyController.php OrganisationPrivacyController::update */
export function useOrganisationPrivacyUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		OrganisationPrivacyUpdateResponse,
		AxiosError<OrganisationPrivacyUpdateError>,
		OrganisationPrivacyUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: organisationPrivacyUpdateMutationKey(),
		mutationFn: ({ organisation, data }: OrganisationPrivacyUpdateVariables) =>
			organisationPrivacyUpdate(organisation, data, config).then(res => res.data),
		...options,
	})
}
